export const FORM_CAPTION = 'Note: This is case sensitive';
